module.exports = __webpack_public_path__ + "static/media/5.82523850.png";